/**
 * Route definitions for the Employees module.
 * Lazily loads page components for employees list and employee details.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const EmployeesRoutes = createFeatureRoutes(
  'employees',
  {
    list: () => import('../presentation/pages/EmployeesPage'),
    details: () => import('../presentation/pages/EmployeeDetails')
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'create', pageKey: 'details' },
    { path: ':id', pageKey: 'details' }
  ]
);

export default EmployeesRoutes;
